/** @format */

import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Input, Modal } from "antd";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";

import pdf from "../../../../../icons/pdf.png";
import print from "../../../../../icons/print.png";
import excel from "../../../../../icons/excel.png";
import {
  monthDays,
  monthName,
} from "../../../../../components/functions/Month";
import LineChartComponent from "../components/newLineChart";
import { header } from "../../../../../components/api/Header";
import LoadingCard from "../../../../../components/loading/loadingCard";
import { ExcelPrint, Pdf } from "../../../../../components/functions/Print";
import { getEnv } from "../../../../../lib/env";

const buttonList = [
  { mode: "first", label: "I dekada" },
  { mode: "second", label: "II dekada" },
  { mode: "third", label: "III dekada" },
  { mode: "all", label: "Batafsil" },
];

function Page3({ month }) {
  let day = 1;
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isSelectData, setIsSelectData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  const getInitialViewMode = () => {
    const day = new Date().getDate();
    if (day >= 1 && day <= 10) return "first";
    if (day >= 11 && day <= 20) return "second";
    return "third";
  };

  const [viewMode, setViewMode] = useState(getInitialViewMode());

  const daysInMonth = new Date(
    new Date(month).getFullYear(),
    new Date(month).getMonth() + 1,
    0
  ).getDate();

  const onSelectData = (value) => {
    setIsSelectData(value);
    setIsOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/republik/sirdaryo/table?month=${month}`,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.error("Xato:", e);
        alert("Serverga ulanishda xato");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [month]);

  useEffect(() => {
    if (loading) return;

    const todayCol = document.getElementById("istoday-balans-sir");

    if (todayCol) {
      todayCol.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [loading, viewMode]);

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF"),
  });

  const getChunkRange = (mode) => {
    switch (mode) {
      case "first":
        return { start: 1, end: 10 };
      case "second":
        return { start: 11, end: 20 };
      case "third":
        return { start: 21, end: daysInMonth };
      case "all":
        return { start: 1, end: daysInMonth };
      default:
        return { start: 1, end: 10 };
    }
  };

  const { start, end } = getChunkRange(viewMode);

  const range = Array.from({ length: end - start + 1 }, (_, i) => start + i);

  const filteredData = data?.filter((item) =>
    item.nomi?.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className='table-box-con'>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        <div
          style={{
            display: "flex",
            gap: "0.75rem",
          }}>
          <ul className='tabs-component'>
            {buttonList.map((btn, index) => (
              <li key={`${btn.mode}-${index}`}>
                <button
                  className={viewMode === btn.mode ? "active" : ""}
                  onClick={() => setViewMode(btn.mode)}>
                  {btn.label}
                </button>
              </li>
            ))}
          </ul>

          <ul className='table-top-right'>
            <li>
              <button className='btn p-0' onClick={() => generatePDF()}>
                <img src={print} alt='404' />
              </button>
            </li>

            <li>
              <button onClick={() => Pdf("sirdaryo")} className='btn p-0'>
                <img src={pdf} alt='404' />
              </button>
            </li>

            <li>
              <button
                className='btn p-0'
                onClick={() =>
                  ExcelPrint("Sirdaryo balans", month, "sirdaryo")
                }>
                <img src={excel} alt='404' />
              </button>
            </li>
          </ul>
        </div>
      </div>

      {loading ? (
        <LoadingCard loading={loading} heightSize='80vh' />
      ) : (
        <div className='table-responsive tableFixHead' id='tableFlexible'>
          <div ref={conponentPDF} style={{ width: "100%" }}>
            <table className='table table-bordered table-style' id='sirdaryo'>
              <thead>
                <tr>
                  <th rowSpan={2} scope='col' className='sticky st1'>
                    №
                  </th>

                  <th
                    rowSpan={2}
                    scope='col'
                    className='sticky'
                    style={{ left: "36px", width: "350px" }}>
                    Suv olish nuqtalari
                  </th>

                  <th
                    rowSpan={2}
                    scope='col'
                    className='sticky'
                    style={{ left: "286px" }}>
                    Birligi
                  </th>

                  <th colSpan={range.length} scope='col'>
                    {monthName(month)}
                  </th>

                  <th
                    style={{
                      width: "100px",
                      maxWidth: "100px",
                      minWidth: "100px",
                    }}
                    scope='col'
                    rowSpan={2}>
                    O'rtacha
                  </th>

                  <th
                    style={{
                      width: "110px",
                      maxWidth: "110px",
                      minWidth: "110px",
                    }}
                    scope='col'
                    rowSpan={2}>
                    Hajm (mln m3)
                  </th>

                  <th
                    style={{
                      width: "110px",
                      maxWidth: "110px",
                      minWidth: "110px",
                    }}
                    scope='col'
                    rowSpan={2}>
                    Eng past qiymat
                  </th>

                  <th
                    style={{
                      width: "110px",
                      maxWidth: "110px",
                      minWidth: "110px",
                    }}
                    scope='col'
                    rowSpan={2}>
                    Eng yuqori qiymat
                  </th>
                </tr>

                <tr>
                  {range.map((day, index) => {
                    return (
                      <th scope='col' key={`table1-${day + index}`}>
                        {day}
                      </th>
                    );
                  })}
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td
                    style={{
                      background: "#0b4aa912",
                    }}
                    className='text-center'
                    colSpan={monthDays(month) + 7}>
                    <b>Norin daryosi</b>
                  </td>
                </tr>
              </tbody>

              {filteredData
                ? filteredData.map((d, i) => {
                    return (
                      <tbody key={i}>
                        {i === 17 ? (
                          <tr>
                            <td
                              style={{
                                background: "#0b4aa912",
                              }}
                              className='text-center'
                              colSpan={monthDays(month) + 7}>
                              <b>Qoradaryo</b>
                            </td>
                          </tr>
                        ) : null}

                        {i === 45 ? (
                          <tr>
                            <td
                              style={{
                                background: "#0b4aa912",
                              }}
                              className='text-center'
                              colSpan={monthDays(month) + 7}>
                              <b>Sirdaryo</b>
                            </td>
                          </tr>
                        ) : null}

                        <tr
                          onClick={() => onSelectData(d)}
                          className={d.nomi + " tr"}>
                          <th
                            scope='row'
                            className='sticky st1'
                            style={{
                              width: "36px",
                              minWidth: "36px",
                              maxWidth: "36px",
                              textAlign: "center",
                            }}>
                            {day++}
                          </th>

                          <td
                            className='fix-with sticky'
                            style={{ left: "36px" }}>
                            {d.nomi}
                          </td>

                          <td
                            className='sticky'
                            style={{
                              left: "280px",
                              width: "80px",
                              minWidth: "80px",
                              maxWidth: "80px",
                            }}>
                            {d.birligi}
                          </td>

                          {range.map((kun) => {
                            const today = new Date().getDate();
                            const istoday =
                              today === kun && viewMode === "all" ? day : null;

                            return (
                              <td
                                id={
                                  day === istoday
                                    ? "istoday-balans-sir"
                                    : undefined
                                }
                                style={{
                                  width: "60px",
                                  maxWidth: "60px",
                                  minWidth: "60px",
                                  color:
                                    d["kun" + kun] === null ? "red" : "#25213b",
                                }}
                                key={kun}>
                                {d["kun" + kun] === null ? "-" : d["kun" + kun]}
                              </td>
                            );
                          })}

                          <td style={{ width: "100px" }}>
                            {ortacha_oqim_tezligi(d.birligi, d, range)}
                          </td>

                          <td style={{ width: "100px" }}>
                            {ortacha_hajm(d.birligi, d, range)}
                          </td>

                          <td style={{ width: "100px" }}>
                            {min_value(d, range)}
                          </td>

                          <td style={{ width: "100px" }}>
                            {max_value(d, range)}
                          </td>
                        </tr>
                      </tbody>
                    );
                  })
                : null}
            </table>
          </div>
        </div>
      )}

      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        centered
        style={{
          minWidth: "1200px",
        }}
        title={isSelectData?.nomi}>
        <LineChartComponent month={month} monthlyData={isSelectData} />
      </Modal>
    </div>
  );
}

export default Page3;

const ortacha_oqim_tezligi = (birligi, qiymat, range) => {
  if (birligi === "mln m3") return "";

  const values = range
    .map((day) => Number(qiymat["kun" + day]))
    .filter((v) => !isNaN(v));

  if (values.length === 0) return "";

  const sum = values.reduce((acc, v) => acc + v, 0);
  return (sum / range.length).toFixed(1);
};

const ortacha_hajm = (birligi, qiymat, range) => {
  if (birligi === "mln m3") {
    const values = range
      .map((day) => Number(qiymat["kun" + day]))
      .filter((v) => !isNaN(v));

    return values[range.length - 1];
  }

  if (birligi !== "m3/sek") return "";

  const values = range
    .map((day) => Number(qiymat["kun" + day]))
    .filter((v) => !isNaN(v));

  if (values.length === 0) return "";

  const sum = values.reduce((acc, v) => acc + v, 0);
  return ((sum * 24 * 3600) / 1_000_000 / range.length).toFixed(1);
};

const min_value = (qiymat, range) => {
  const values = range
    .map((day) => Number(qiymat["kun" + day]))
    .filter((v) => !isNaN(v));

  if (values.length === 0) return "";

  return Math.min(...values).toFixed(1);
};

const max_value = (qiymat, range) => {
  const values = range
    .map((day) => Number(qiymat["kun" + day]))
    .filter((v) => !isNaN(v));

  if (values.length === 0) return "";

  return Math.max(...values).toFixed(1);
};
